var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgCheck = function SvgSvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.148 7.057c-.592-.533-1.555-.533-2.074.076l-5.704 6.47-2.444-2.74c-.296-.304-.667-.533-1.037-.533-.445 0-.815.153-1.111.457-.296.305-.445.61-.445 1.066 0 .38.149.761.37 1.065l3.63 3.959c.297.304.667.456 1.111.456.445 0 .815-.152 1.112-.532l6.74-7.612c.223-.229.37-.685.37-1.066 0-.38-.221-.761-.518-1.066Z",
    fill: "currentColor"
  })));
};
export default SvgSvgCheck;